// extracted by mini-css-extract-plugin
export default {"aside":"Aside_aside__pp2+D","aside--noPaddin":"Aside_aside--noPaddin__6tyf+"};